import React from 'react';
import { PropTypes } from 'prop-types';
import { useSelector } from 'react-redux';
import { selectShowManageLeftFilters } from 'store/Manage/selectors';
import { selectShowHostLeftFilters } from 'store/Host/selectors';
import Filters from '../../../Filters';
import { selectShowVulnsSidebarFilters } from 'store/Contextualization/AssetDetail/selectors';
import { selectShowRightFilters } from 'store/HostsGeneral/selectors';
import { selectShowManageRightFilters } from 'store/ManageGeneral/selectors';

const FilterSideBar = ({ entity }) => {
  const showFilters = useSelector((state) => {
    if (entity === 'vulns') return selectShowManageLeftFilters(state);
    if (entity === 'assets') return selectShowHostLeftFilters(state);
    if (entity === 'vulnsAssets') return selectShowVulnsSidebarFilters(state);
    if (entity === 'assetsGeneral') return selectShowRightFilters(state);
    if (entity === 'vulnsGeneral') return selectShowManageRightFilters(state);
    return false;
  });

  return showFilters && <Filters entity={ entity } />;
};

FilterSideBar.propTypes = {
  entity: PropTypes.string.isRequired
};

export default FilterSideBar;
